import { injectable } from 'tsyringe'
import { NotificationApiRepository } from '@/app/repositories/api/NotificationApiRepository'
import { Notification } from '@/domain/entities/Notification'
import {
  PostNotificationInterface,
  DeleteNotificationInterface,
  UpdateNotificationInterface,
} from '@/data/payload/contracts/NotificationRequest'
@injectable()
export class NotificationPresenter {
  private repository: NotificationApiRepository

  constructor(repository: NotificationApiRepository) {
    this.repository = repository
  }

  public loadNotification(params: Object): Promise<Notification> {
    return this.repository.getAll(params)
  }

  public postNotification(
    payload: PostNotificationInterface
  ): Promise<Notification> {
    return this.repository.post(payload)
  }

  public updateNotification(
    payload: UpdateNotificationInterface,
    id: number
  ): Promise<Notification> {
    return this.repository.update(payload, id)
  }

  public deleteNotification(
    payload: DeleteNotificationInterface
  ): Promise<Notification> {
    return this.repository.delete(payload)
  }
}
